import React, { ReactNode } from 'react';
import { BooleanField, DateField, EditButton, TextField } from 'react-admin';
import CustomizableGrid from '../components/CustomizableGrid';
import { ColumnConfig } from '../hooks/useColumnReorder';
import CountryField from '../components/CountryField';

const CouponList = ({ permissions = [], ...props }) => {
    // Define default columns configuration
    const defaultColumns: ColumnConfig[] = [
        { id: 'serial', label: 'Serial', visible: true, order: 0 },
        { id: 'createdAt', label: 'Created', visible: true, order: 1 },
        { id: 'id', label: 'ID', visible: true, order: 2 },
        { id: 'reusable', label: 'Reusable', visible: true, order: 3 },
        { id: 'expiry', label: 'Expiry', visible: true, order: 4 },
        { id: 'country', label: 'Country', visible: true, order: 5 },
        { id: 'edit', label: 'Edit', visible: true, order: 6 },
    ];

    // Function to render column based on column ID
    const renderColumn = (columnId: string): ReactNode => {
        switch (columnId) {
            case 'serial':
                return (
                    <TextField
                        key={columnId}
                        source="serial"
                        sortable={false}
                    />
                );
            case 'createdAt':
                return (
                    <DateField
                        key={columnId}
                        source="createdAt"
                        label="Created"
                    />
                );
            case 'id':
                return <TextField key={columnId} source="id" />;
            case 'reusable':
                return <BooleanField key={columnId} source="reusable" />;
            case 'expiry':
                return (
                    <DateField key={columnId} locales="en-IN" source="expiry" />
                );
            case 'country':
                return <CountryField key={columnId} />;
            case 'edit':
                return <EditButton key={columnId} />;
            default:
                return null;
        }
    };

    // Ensure we have all required props, but avoid duplicates with what might be in props
    const combinedProps = {
        title: 'Coupons',
        permissions,
        defaultColumns,
        storageKey: 'couponListColumns',
        renderColumn,
        ...props,
        // Ensure these are set if not in props
        resource: props.resource || 'coupons',
        location: props.location || { search: '' },
        hasShow: props.hasShow !== undefined ? props.hasShow : false,
    };

    return <CustomizableGrid {...combinedProps} />;
};

CouponList.defaultProps = {
    resource: 'coupons',
    location: { search: '' },
};

export default CouponList;
